import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <div className="py-16 sm:py-20 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 rounded-3xl p-12 sm:p-16 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          
          <div className="relative z-10">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Noto Sans, system-ui, sans-serif' }}>
              Ready to Transform Your Church's Digital Presence?
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
              Join hundreds of churches already using Worship Hub Nigeria to reach more believers
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/directory"
                className="px-8 py-4 bg-emerald-600 text-white rounded-lg font-bold text-lg hover:bg-emerald-700 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
              >
                Get Started Today
              </Link>
              <Link
                to="/tools"
                className="px-8 py-4 bg-white text-slate-800 rounded-lg font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
              >
                Explore Tools
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
